import API from '../services/api';

const api = new API();
const URL_PARTNER_SIGNUP_SUBMIT = '/signup/submit/partner';
const URL_RESEND_EMAIL = '/signup/resend_email';

export default class PartnerSignupService {
    submitPartnerSignupForm(data) {
        return api.getJson(URL_PARTNER_SIGNUP_SUBMIT, {
            method: 'POST',
            legacyStatus: true,
            body: {
                full_name: data.fullName,
                email: data.email,
                password: data.password,
                company_name: data.companyName,
                working_with_advertisers: data.workingWithAdvertisers,
                has_live_integration: data.hasLiveIntegration,
                recaptcha_token: data.recaptchaToken,
            },
        });
    }

    resendEmail(data) {
        return api.getJson(URL_RESEND_EMAIL, {
            method: 'POST',
            legacyStatus: true,
            body: {
                email: data.email,
            },
            fixErr: true,
        });
    }
}
